import React, { lazy, Suspense } from "react";
import { RootStateOrAny, useSelector } from "react-redux";
import { BrowserRouter, Switch } from "react-router-dom";

import Loader from "../../components/Loader/Loader";

import { PrivateRoutes, PublicRoutes } from "./Routes";

// Containers
const DefaultLayout = lazy(() => import("../DefaultLayout/DefaultLayout"));

const MainRouter: React.FC = () => {
	const { authenticated, profile, permissions } =
		useSelector((state: RootStateOrAny) => state.auth) || {};

	return (
		<BrowserRouter>
			<Suspense fallback={<Loader />}>
				{authenticated ? (
					<DefaultLayout>
						<PrivateRoutes
							authenticated={authenticated}
							user={{
								...profile,
								permissions,
							}}
						/>
					</DefaultLayout>
				) : (
					<Switch>
						<PublicRoutes authenticated={authenticated} />
					</Switch>
				)}
			</Suspense>
		</BrowserRouter>
	);
};

export default MainRouter;
